/** Share the document lock across dialogs and navigation drawers. */
const locks = new WeakMap<HTMLElement, {
  owners: Set<symbol>;
  overflow: string;
  priority: string;
}>();

export function lockBodyScroll(body: HTMLElement = document.body): () => void {
  let state = locks.get(body);
  if (!state) {
    state = {
      owners: new Set(),
      overflow: body.style.getPropertyValue("overflow"),
      priority: body.style.getPropertyPriority("overflow"),
    };
    locks.set(body, state);
    body.style.setProperty("overflow", "hidden");
  }
  const owner = Symbol("body-scroll-lock");
  state.owners.add(owner);
  return () => {
    if (!state.owners.delete(owner) || state.owners.size > 0) return;
    if (state.overflow) {
      body.style.setProperty("overflow", state.overflow, state.priority);
    } else {
      body.style.removeProperty("overflow");
    }
    locks.delete(body);
  };
}
